export const accountFromLocalStorage = () => localStorage.getItem('ngStorage-currentAccount');
